import { StatisticProps } from 'antd';
import { IglooTypographyProps } from 'iglooform/es/typography';
import { FC, useMemo } from 'react';
import { AdminAmount } from 'iglooform';
import { useIntl } from 'react-intl';

interface IProps extends StatisticProps {
  amount: number;
  level?: IglooTypographyProps['level'];
}

const Amount: FC<IProps> = ({ ...rest }) => {
  const { locale } = useIntl();

  const amountProps = useMemo(
    () => ({
      groupSeparator: locale === 'vi-VN' ? '.' : ',',
      decimalSeparator: locale === 'vi-VN' ? ',' : '.',
      precision: 0,
    }),
    [locale],
  );

  return <AdminAmount {...amountProps} {...rest} />;
};

export default Amount;
